import { render } from "./instructionsdetailview.vue?vue&type=template&id=623dafad"
import script from "./instructionsdetailview.vue?vue&type=script&lang=js"
export * from "./instructionsdetailview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__